import { useSelector } from 'react-redux'
import { AppState } from '@/types'
import { EducationalProgramItem } from './EducationalProgramItem'

export function EducationalProgramsList() {
    const educationalPrograms = useSelector((state: AppState) => {
        return state.educationalPrograms.data.filter(
            (program) =>
                program.programType?.id ===
                state.programTypes.selectedProgramType?.id
        )
    })

    return (
        <div className="flex flex-col border border-black rounded-xl overflow-hidden">
            {educationalPrograms.map((program, index) => (
                <EducationalProgramItem
                    key={program.id}
                    program={program}
                    index={index}
                />
            ))}
        </div>
    )
}
